module.exports = __webpack_public_path__ + "static/media/img-06.0765ac60.png";